import {curry, defaultTo} from 'ramda';

/**
 *
 * @param {string} selector
 * @param {HTMLElement} node
 * @returns {HTMLElement}
 */
const querySelector = (selector, node) => defaultTo(document, node).querySelector(selector);

export default querySelector;
export const curriedQuerySelector = curry(querySelector);
